var _path, _rect, _circle, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 171,
    viewBox: "0 0 239 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119 156C119 156 177 109 177 58C177 25.9675 151.033 0 119 0C86.9675 0 61 25.9675 61 58C61 109 119 156 119 156ZM119 83C133.359 83 145 71.3594 145 57C145 42.6406 133.359 31 119 31C104.641 31 93 42.6406 93 57C93 71.3594 104.641 83 119 83Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 119,
    width: 237,
    height: 51,
    rx: 25.5,
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 206.56,
    cy: 142.56,
    r: 9.06,
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 214.441,
    y1: 149.28,
    x2: 219.04,
    y2: 153.879,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSearch);
export default __webpack_public_path__ + "static/media/illustration-search.acdd9bdca28908c8aa9506d3d3c1a0f4.svg";
export { ForwardRef as ReactComponent };